import { createFileRoute } from '@tanstack/react-router'
import LegalPage from '../landing/LegalPage'

export const Route = createFileRoute('/cookie-policy')({
  component: RouteComponent,
})

function RouteComponent() {
  return <LegalPage />
}
